import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage, t } from '../../utils/i18n';
import { ReactComponent as TikTokIcon } from '../../assets/icons/tiktok.svg';
import { ReactComponent as Logo } from '../../assets/icons/logo.svg';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();

  return (
    <footer className="relative text-white">
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ backgroundImage: 'url("/assets/woodloggray.jpg")' }}
      />
      <div className="absolute inset-0 bg-black/40 z-0" />

      <div className="relative z-10">
        <div className="container-custom py-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-center">
            <div 
              className="col-span-1 p-2 flex flex-col items-center text-center md:items-start md:text-left"
            >
              <Link to="/" className="block mb-1">
                <Logo 
                  alt="Akasha Concept Store" 
                  className="h-12 w-auto text-white"
                  style={{ filter: 'brightness(0) invert(1)' }} 
                />
              </Link>
              <p className="text-xs italic mb-1">{t('home.hero.title', language.code)}</p>
              <div className="flex space-x-3 mt-auto pt-1">
                <a 
                  href="https://www.facebook.com/akashaconceptstore/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="text-white hover:text-gray-300 transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                  </svg>
                </a>
                <a 
                  href="https://www.instagram.com/akashaconceptstore/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="text-white hover:text-gray-300 transition-colors"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a 
                  href="https://www.tiktok.com/@akasha.concept.st" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                  className="text-white hover:text-gray-300 transition-colors"
                >
                  <TikTokIcon className="h-5 w-5" fill="currentColor" />
                </a>
              </div>
            </div>

            <div 
              className="col-span-1 p-2 text-center md:text-left"
            >
              <h3 className="text-md font-semibold mb-1">{t('footer.links', language.code)}</h3>
              <ul className="space-y-0.5 text-sm">
                <li>
                  <Link to="/" className="hover:text-gray-300 transition-colors">
                    {t('nav.home', language.code)}
                  </Link>
                </li>
                <li>
                  <Link to="/catalog" className="hover:text-gray-300 transition-colors">
                    {t('nav.catalog', language.code)}
                  </Link>
                </li>
                <li>
                  <Link to="/store" className="hover:text-gray-300 transition-colors">
                    {t('nav.store', language.code)}
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="hover:text-gray-300 transition-colors">
                    {t('nav.about', language.code)}
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-gray-300 transition-colors">
                    {t('nav.contact', language.code)}
                  </Link>
                </li>
              </ul>
            </div>

            <div 
              className="col-span-1 p-2 text-center md:text-left"
            >
              <h3 className="text-md font-semibold mb-1">Legal</h3>
              <ul className="space-y-0.5 text-sm mb-1">
                <li>
                  <Link to="/legal/terms" className="hover:text-gray-300 transition-colors">
                    {t('footer.terms', language.code)}
                  </Link>
                </li>
                <li>
                  <Link to="/legal/privacy" className="hover:text-gray-300 transition-colors">
                    {t('footer.privacy', language.code)}
                  </Link>
                </li>
              </ul>
              <p className="text-xs mt-1">
                &copy; {currentYear} Akasha Concept Store. {t('footer.copyright', language.code)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
